module.exports = __webpack_public_path__ + "img/email.6f57fe45.png";